import React from 'react';
import { IconType } from 'react-icons';

// react-icons components return React.ReactNode, but React 19's JSX typing
// expects React.JSX.Element from function components -- this wraps any
// IconType into a properly-typed component.
export const wrapIcon = (Icon: IconType): React.FC<{ className?: string }> => {
  return ({ className }) => Icon({ className }) as React.JSX.Element;
};
